import { StatusBadge, StatusChip, StatusDot, STATUS_CONFIG, STATUS_VARIANT } from "@repo/design-system/components/ui";


export const BadgeRenderer = (col, columnEvents) => {

    return (rowData) => {

        const value = rowData?.[col.field];
        if (value == null || value === "") return "-";
        const statusKey = value.toString().replace(/\s+/g, "").toUpperCase();

        const { variant = STATUS_VARIANT.BADGE, size } = col?.config?.statusRenderer || {};

        const badgeConfig = col?.config?.statusRenderer?.statusConfig?.[statusKey];

        if (!badgeConfig && !STATUS_CONFIG[statusKey]) {
            return value ?? "-";
        }

        const handler = columnEvents?.BADGE;
        const handleClick = handler
            ? () => handler(value, "", rowData)
            : undefined;

        const {
            showIcon, showLabel,
            iconName, ...otherIconConfig
        } = badgeConfig ?? {};


        const renderVariant = () => {
            if (variant === STATUS_VARIANT.DOT) {
                return (
                    <StatusDot status={statusKey} size={size}
                        showIcon={showIcon} showLabel={showLabel}
                        iconName={iconName} onClick={handleClick}
                        {...otherIconConfig} />
                );
            }
            if (variant === STATUS_VARIANT.CHIP) {
                return (
                    <StatusChip status={statusKey} size={size}
                        showIcon={showIcon} iconName={iconName}
                        onClick={handleClick}
                        {...otherIconConfig} />
                );
            }
            if (variant === STATUS_VARIANT.BADGE) {
                return (
                    <StatusBadge status={statusKey} size={size}
                        showIcon={showIcon} iconName={iconName}
                        onClick={handleClick}
                        {...otherIconConfig} />
                );
            }
        };

        return renderVariant();
    };
};